import React, { Fragment } from "react";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Candidate from "../../apiResources/Candidate";
import { AddButton } from "./styles/add-new-candidate-styles";
import CandidateCreateModal from "../CandidateCreateModal";
import { useModal, useFlash } from "../../hooks";
import FlashMessage from "../shared/general/FlashMessage";

const AddNewCandidate = (props: Props) => {
  const modal = useModal(false);
  const flash = useFlash();

  const { onSuccess } = props;

  const success = (candidate: Candidate) => {
    onSuccess(candidate);
    modal.close();
    flash.show();
  };

  return (
    <Fragment>
      <ReactTooltip
        place="left"
        type="dark"
        effect="solid"
        aria-haspopup="true"
        id="add-candidate-tooltip"
      />
      <FlashMessage
        message="Successfully created new candidate"
        success
        showFlashMessage={flash.visible}
      />
      <AddButton
        id="add-candidate-button"
        onClick={() => {
          modal.open();
        }}
        title="Add new candidate"
        data-tip="Add new candidate"
        data-for="add-candidate-tooltip"
      >
        <FontAwesomeIcon icon={faPlus} />
      </AddButton>
      <CandidateCreateModal
        isOpen={modal.isOpen}
        onDismiss={modal.close}
        onSuccess={success}
      />
    </Fragment>
  );
};

type Props = {
  onSuccess: (candidate: Candidate) => void;
};

export default AddNewCandidate;
